import { format } from "date-fns";

type Event = {
  title: string;
  start: Date;
  end: Date;
};

const events: Event[] = [
  {
    title: "Lecture prep",
    start: new Date(2025, 5, 6, 9, 0),
    end: new Date(2025, 5, 6, 10, 30),
  },
  {
    title: "Student consultations",
    start: new Date(2025, 5, 6, 11, 0),
    end: new Date(2025, 5, 6, 12, 0),
  },
  {
    title: "Marking block",
    start: new Date(2025, 5, 6, 14, 0),
    end: new Date(2025, 5, 6, 17, 0),
  },
];

import heroTimeLight from "../assets/images/hero-time-light-pexels.jpeg";
import heroTimeDark from "../assets/images/hero-time-dark-pexels.jpeg";

export default function TimeManagementPage() {
  return (
    <>
      <section className="relative mb-8 overflow-hidden rounded-2xl">
        <img
          src={heroTimeLight}
          alt="Organised desk planner in daylight"
          className="theme-light-only absolute inset-0 h-56 w-full object-cover md:h-72"
        />
        <img
          src={heroTimeDark}
          alt="Notebook and laptop with dim lighting for late-night planning"
          className="theme-dark-only absolute inset-0 h-56 w-full object-cover md:h-72"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-white/60 via-white/40 to-white" />
        <div className="relative z-10 p-6">
          <h1 className="text-2xl font-semibold text-gray-900">Time Management</h1>
          <p className="mt-1 text-gray-700">Plan and track your day.</p>
          {/* Credits – light */}
          <p className="mt-2 text-xs text-gray-500 dark:hidden">
            Photo by{' '}
            <a
              href="https://www.pexels.com/@ann-h-45017"
              target="_blank"
              rel="noreferrer"
              className="underline"
            >
              Ann H
            </a>{' '}
            on{' '}
            <a
              href="https://www.pexels.com"
              target="_blank"
              rel="noreferrer"
              className="underline"
            >
              Pexels
            </a>
          </p>

          {/* Credits – dark */}
          <p className="mt-2 hidden text-xs text-gray-400 dark:block">
            Photo by{' '}
            <a
              href="https://www.pexels.com/@timamiroshnichenko"
              target="_blank"
              rel="noreferrer"
              className="underline"
            >
              Tima Miroshnichenko
            </a>{' '}
            on{' '}
            <a
              href="https://www.pexels.com"
              target="_blank"
              rel="noreferrer"
              className="underline"
            >
              Pexels
            </a>
          </p>
        </div>
      </section>

      <div className="space-y-4">
        <div className="space-y-2 rounded-lg border bg-white p-6 shadow-sm">
        {events.map((e) => (
          <div
            key={e.title}
            className="flex items-center justify-between rounded-md bg-gray-50 px-4 py-3"
          >
            <span>{e.title}</span>
            <span className="text-sm text-gray-600">
              {format(e.start, "HH:mm")} – {format(e.end, "HH:mm")}
            </span>
          </div>
        ))}
        </div>
      </div>
    </>
  );
}
